var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { joiResolver } from '@hookform/resolvers/joi';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@interfaces/keychain.interface';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { loadDelegatees } from '@popup/steem/actions/delegations.actions';
import { PowerType } from '@popup/steem/pages/app-container/home/power-up-down/power-type.enum';
import { ResourceItemComponent } from '@popup/steem/pages/app-container/home/resources-section/resource-item/resource-item.component';
import AccountUtils from '@popup/steem/utils/account.utils';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import { FavoriteUserUtils } from '@popup/steem/utils/favorite-user.utils';
import { PowerUtils } from '@popup/steem/utils/power.utils';
import Joi from 'joi';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { CustomTooltip } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
import { FormContainer } from 'src/common-ui/form-container/form-container.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { FormInputComponent } from 'src/common-ui/input/form-input.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import { Separator } from 'src/common-ui/separator/separator.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { Screen } from 'src/reference-data/screen.enum';
import { FormUtils } from 'src/utils/form.utils';
import FormatUtils from 'src/utils/format.utils';
const rules = FormUtils.createRules({
    receiver: Joi.string().required(),
    amount: Joi.number().required().positive().max(Joi.ref('$maxAmount')),
});
const PowerUpDown = ({ currencyLabels, activeAccount, powerType, globalProperties, formParams, delegations, localAccounts, navigateToWithParams, navigateTo, setSuccessMessage, setErrorMessage, loadDelegatees, addToLoadingList, removeFromLoadingList, setTitleContainerProperties, }) => {
    const { control, handleSubmit, setValue, watch } = useForm({
        defaultValues: {
            receiver: formParams.receiver ? formParams.receiver : activeAccount.name,
            amount: formParams.amount ? formParams.amount : '',
            currency: powerType === PowerType.POWER_UP
                ? currencyLabels.steem
                : currencyLabels.sp,
        },
        resolver: (values, context, options) => {
            const resolver = joiResolver(rules, {
                context: { maxAmount: available },
                errors: { render: true },
            });
            return resolver(values, { maxAmount: available }, options);
        },
    });
    const [current, setCurrent] = useState('...');
    const [available, setAvailable] = useState('...');
    const [autocompleteFavoriteUsers, setAutocompleteFavoriteUsers] = useState({
        categories: [],
    });
    const loadAutocompleteTransferUsernames = () => __awaiter(void 0, void 0, void 0, function* () {
        const autoCompleteListByCategories = yield FavoriteUserUtils.getAutocompleteListByCategories(activeAccount.name, localAccounts);
        setAutocompleteFavoriteUsers(autoCompleteListByCategories);
    });
    useEffect(() => {
        setTitleContainerProperties({ title: title, isBackButtonEnabled: true });
        loadDelegatees(activeAccount.name);
        loadAutocompleteTransferUsernames();
    }, []);
    const powerDownInfo = AccountUtils.getPowerDown(activeAccount.account, globalProperties.globals);
    useEffect(() => {
        const hiveBalance = FormatUtils.toNumber(activeAccount.account.balance);
        let totalOutgoingVestingShares = 0;
        for (const delegation of delegations.outgoing) {
            totalOutgoingVestingShares += parseFloat(delegation.vesting_shares.toString().split(' ')[0]);
        }
        const hpBalance = (FormatUtils.toSP((parseFloat(activeAccount.account.vesting_shares
            .toString()
            .replace('VESTS', '')) - totalOutgoingVestingShares).toString(), globalProperties.globals) - (powerType === PowerType.POWER_UP ? 0 : 5)).toFixed(3);
        setAvailable(powerType === PowerType.POWER_UP
            ? hiveBalance
            : Math.max(Number(hpBalance), 0));
        setCurrent(powerType === PowerType.POWER_UP ? hpBalance : hiveBalance);
    }, [activeAccount, delegations]);
    const title = powerType === PowerType.POWER_UP ? 'popup_html_pu' : 'popup_html_pd';
    const text = powerType === PowerType.POWER_UP
        ? 'popup_html_powerup_text'
        : 'popup_html_powerdown_text';
    const handleButtonClick = (form) => {
        if (form.amount.toString().trim() === '') {
            setErrorMessage('popup_html_fill_form_error');
            return;
        }
        if (powerType === PowerType.POWER_DOWN &&
            Number(form.amount).toFixed(3) === '0.000') {
            return handleCancelButtonClick(form);
        }
        if (parseFloat(form.amount.toString()) > parseFloat(available.toString())) {
            setErrorMessage('popup_html_power_up_down_error');
            return;
        }
        const operationString = getMessage(powerType === PowerType.POWER_UP ? 'popup_html_pu' : 'popup_html_pd');
        const formattedAmount = `${parseFloat(form.amount.toString()).toFixed(3)} ${form.currency}`;
        const stringifiedAmount = `${FormatUtils.formatCurrencyValue(parseFloat(form.amount.toString()))} ${form.currency}`;
        const fields = [];
        if (powerType === PowerType.POWER_UP) {
            fields.push({
                label: 'popup_html_transfer_from',
                value: `@${activeAccount.name}`,
            });
            fields.push({
                label: 'popup_html_transfer_to',
                value: `@${form.receiver}`,
            });
        }
        fields.push({ label: 'popup_html_amount', value: stringifiedAmount });
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_confirm_power_up_down_message', [operationString.toLowerCase()]),
            title: powerType === PowerType.POWER_UP
                ? 'html_popup_power_up'
                : 'html_popup_power_down',
            fields: fields,
            formParams: getFormParams(),
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                let success;
                try {
                    switch (powerType) {
                        case PowerType.POWER_UP:
                            addToLoadingList('html_popup_power_up_operation');
                            success = yield PowerUtils.powerUp(activeAccount.name, form.receiver, formattedAmount, activeAccount.keys.active, options);
                            break;
                        case PowerType.POWER_DOWN:
                            addToLoadingList('html_popup_power_down_operation');
                            success = yield PowerUtils.powerDown(activeAccount.name, `${FormatUtils.fromSP(Number(form.amount).toFixed(3), globalProperties.globals).toFixed(6)} VESTS`, activeAccount.keys.active, options);
                    }
                    if (success) {
                        navigateTo(Screen.HOME_PAGE, true);
                        yield FavoriteUserUtils.saveFavoriteUser(form.receiver, activeAccount);
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else {
                            setSuccessMessage('popup_html_power_up_down_success', [
                                operationString,
                            ]);
                        }
                    }
                    else {
                        setErrorMessage('popup_html_power_up_down_fail', [operationString]);
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_power_up_operation');
                    removeFromLoadingList('html_popup_power_down_operation');
                }
            }),
        });
    };
    const setToMax = () => {
        setValue('amount', Number(available));
    };
    const getFormParams = () => {
        return watch();
    };
    const handleCancelButtonClick = (form) => {
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            title: 'popup_html_confirm_cancel_power_down_title',
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_confirm_cancel_power_down_message'),
            fields: [],
            formParams: getFormParams(),
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_cancel_power_down_operation');
                try {
                    let success = yield PowerUtils.powerDown(activeAccount.name, `${FormatUtils.fromSP('0', globalProperties.globals).toFixed(6)} VESTS`, activeAccount.keys.active, options);
                    if (success) {
                        navigateTo(Screen.HOME_PAGE, true);
                        yield FavoriteUserUtils.saveFavoriteUser(form.receiver, activeAccount);
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else {
                            setSuccessMessage('popup_html_cancel_power_down_success');
                        }
                    }
                    else {
                        setErrorMessage('popup_html_cancel_power_down_fail');
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_cancel_power_down_operation');
                }
            }),
        });
    };
    return (React.createElement("div", { className: "power-up-page", "data-testid": `${Screen.POWER_UP_PAGE}-page` },
        React.createElement("div", { className: "resources" },
            React.createElement(ResourceItemComponent, { icon: SVGIcons.RESOURCE_ITEM_MANA, label: "popup_html_current", value: `${FormatUtils.formatCurrencyValue(current, parseFloat(current.toString()) > 100000 ? 0 : 3)} ${powerType === PowerType.POWER_UP
                    ? currencyLabels.sp
                    : currencyLabels.steem}`, additionalClass: "blue" }),
            React.createElement(ResourceItemComponent, { icon: SVGIcons.RESOURCE_ITEM_WALLET, label: "popup_html_available", value: `${FormatUtils.formatCurrencyValue(available, parseFloat(available.toString()) > 100000 ? 0 : 3)} ${powerType === PowerType.POWER_UP
                    ? currencyLabels.steem
                    : currencyLabels.sp}`, additionalClass: "red" })),
        powerType === PowerType.POWER_DOWN &&
            powerDownInfo &&
            powerDownInfo[1] !== '0' &&
            powerDownInfo[0] !== powerDownInfo[1] && (React.createElement(CustomTooltip, { dataTestId: "custom-tool-tip-next-power-down", message: getMessage('popup_next_powerdown', [
                powerDownInfo[2].split('T').join(', '),
            ]), skipTranslation: true },
            React.createElement("div", { className: "power-down-panel" },
                React.createElement("div", { className: "power-down-text" },
                    getMessage('popup_html_powering_down'),
                    ' ',
                    powerDownInfo[0],
                    " / ",
                    powerDownInfo[1],
                    " ",
                    currencyLabels.sp),
                React.createElement(SVGIcon, { className: "icon-button", icon: SVGIcons.GLOBAL_DELETE, onClick: handleCancelButtonClick })))),
        React.createElement(FormContainer, { onSubmit: handleSubmit(handleButtonClick) },
            React.createElement("div", { className: "text" }, getMessage(text)),
            React.createElement(Separator, { fullSize: true, type: "horizontal" }),
            React.createElement("div", { className: "form-fields" },
                powerType === PowerType.POWER_UP && (React.createElement(FormInputComponent, { dataTestId: "input-receiver", control: control, name: "receiver", type: InputType.TEXT, logo: SVGIcons.INPUT_AT, placeholder: "popup_html_receiver", label: "popup_html_receiver", autocompleteValues: autocompleteFavoriteUsers })),
                React.createElement("div", { className: "amount-panel" },
                    React.createElement(FormInputComponent, { classname: "currency-fake-input", dataTestId: "currency-input", control: control, name: "currency", type: InputType.TEXT, label: "popup_html_currency", disabled: true }),
                    React.createElement(FormInputComponent, { classname: "amount-input", dataTestId: "amount-input", control: control, name: "amount", type: InputType.NUMBER, placeholder: "0.000", skipPlaceholderTranslation: true, label: "popup_html_amount", rightActionClicked: setToMax, rightActionIcon: SVGIcons.INPUT_MAX }))),
            React.createElement(OperationButtonComponent, { dataTestId: "submit-power-up-down", requiredKey: KeychainKeyTypesLC.active, label: title, onClick: handleSubmit(handleButtonClick) }))));
};
const mapStateToProps = (state) => {
    var _a, _b, _c;
    return {
        activeAccount: state.steem.activeAccount,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
        powerType: state.navigation.stack[0].params.powerType,
        globalProperties: state.steem.globalProperties,
        formParams: ((_b = state.navigation.stack[0].previousParams) === null || _b === void 0 ? void 0 : _b.formParams)
            ? (_c = state.navigation.stack[0].previousParams) === null || _c === void 0 ? void 0 : _c.formParams
            : {},
        delegations: state.steem.delegations,
        localAccounts: state.steem.accounts,
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    navigateTo,
    setSuccessMessage,
    setErrorMessage,
    loadDelegatees,
    addToLoadingList,
    removeFromLoadingList,
    setTitleContainerProperties,
});
export const PowerUpDownComponent = connector(PowerUpDown);
